import {
  CreateOmitBaseEntityKeys,
  IBaseEntity,
  UpdateOmitBaseEntityKeys,
} from "../system/BaseEntity";
import {
  INurtureCampaignRule,
} from "./NurtureCampaignRule";

export enum NurtureTrigger {
  None,
  NewInstantValuation,
  NewViewing,
  NewOffer,
  NewReview,
  NewContactUsForm,
  NewRegisterForm,
  NewBlogPostComment,
  NewAreaGuideComment,
  NewMarketReportComment,
}

export const triggerOptions = [
  { label: "None", value: "0" },
  { label: "Valuation", value: "1" },
  { label: "Registration", value: "2" },
  { label: "Form Submission", value: "3" },
  { label: "Portal Qualifier", value: "4" },
  { label: "Website Visit", value: "5" },
];

export interface INurtureCampaign extends IBaseEntity {
  enabled: boolean;
  name: string;
  trigger: NurtureTrigger;
  firstRuleId?: string;
  agencyId?: string;
  rules: INurtureCampaignRule[];
}

export interface NurtureCampaignCreate
  extends Omit<INurtureCampaign, CreateOmitBaseEntityKeys | "rules"> {}

export interface NurtureCampaignUpdate
  extends Omit<INurtureCampaign, UpdateOmitBaseEntityKeys | "rules"> {}
